import {req,importFile } from './axiosFun';
/**
 *用户管理
 */
// 查询用户分页
export const qryUserList = (params) => { return req("post", "/huichen-ui/course/qryUser", params) };
export const upUser = (params) => { return req("post", "/huichen-ui/course/upUser", params) };





// WEBPACK FOOTER //
// ./src/api/userApi.js